
import React from 'react';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { IndustrySectionProps } from './types';
import { Button } from '@/components/ui/button';

const IndustrySection: React.FC<IndustrySectionProps> = ({
  businessDetails,
  handleSelectChange,
  industryOptions,
  onSaveIndustry,
  industryComplete,
  handleSubmit
}) => {
  return (
    <div className="flex items-center justify-between gap-4">
      <div className="flex-grow">
        <Select
          value={businessDetails.industryId || ''}
          onValueChange={(value) => handleSelectChange(value, 'industry')}
        >
          <SelectTrigger className="focus:border-gray-900 focus:ring-0 focus:ring-offset-0">
            <SelectValue placeholder="Select industry" />
          </SelectTrigger>
          <SelectContent>
            {industryOptions.map((industry) => (
              <SelectItem key={industry.value} value={industry.value}>
                {industry.label}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>
    </div>
  );
};

export default IndustrySection;
